<template>
  <nav>
    <ul>
      <li v-for="routes in links" v-bind:key="routes.id">
        <router-link
        :to="`${routes.page}`">{{routes.text}}</router-link>
      </li>
      <li v-if="$parent.key" v-for="authRoutes in authLinks" v-bind:key="authRoutes.id" >
        <router-link
          :to="`${authRoutes.page}`">{{authRoutes.text}}</router-link>
      </li>
      <li v-if="user.isAdmin">
        <router-link :to="{ name: 'Stats', params: {} }">Stats</router-link>

      </li>
      <li v-if="$parent.key"><a href="" @click="logout">Logout</a></li>
    </ul>
  </nav>
</template>

<script>
import {store} from '@/store'
import { deleteDB } from 'idb'
import API from '@/data/api.js'
import DataMain from '@/data/dataMain'
export default {
  name: 'Navigation',
  data () {
    return {
      links: [
        {
          id: 0,
          text: 'Home',
          page: '/'
        }
      ],
      authLinks: [
        {
          id: 1,
          text: 'Activities',
          page: '/activities'
        },
        {
          id: 2,
          text: 'Account',
          page: '/account'
        }
      ]

    }
  },
  computed: {
    user () {
      return store.state.user
    }
  },
  methods: {
    async logout () {
      deleteDB('EverydayDB')
      API.logout()
      store.commit('emptyStore', {
        key: null
      })
      DataMain.removeSyncCheck()
      this.$cookie.delete('key')
      this.$router.push('/login')
    },
    mounted () {
      console.log(this.user)
    }
  }
}
</script>

<style lang="scss">

 @import '../../scss/variables/variables';
  nav {
    ul {
      list-style: none;
      li {
        display: inline;
        margin: 0 5px;
      }
    }
    a {
      color: $brandSalmon;
      text-decoration: none;
      &:hover {
        text-decoration: overline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navigation.vue